<div *ngFor="let item of data.items" class="app-single">
  <app-picture class="image" *ngIf="item.media.value && item.media.value.image" [data]="item.media.value.image"  [ratio]="370 / 700"></app-picture>

  <div class="text rte">
    <h2 class="title">{{ item.title.value }}</h2>
    <div class="description" [innerHTML]="item.description.value"></div>
    <app-button class="link" [data]="item.link.value" [withArrow]="true"></app-button>
  </div>
</div>
